import React from 'react'
import ReactDOM from 'react-dom'
import { OmInput, OmButton, OmDropdownMenu } from '@owma/kit'
import { withTranslation, WithTranslation } from 'react-i18next'
import { withRouter, RouteComponentProps } from 'router'
import classNames from 'classnames'
// import { getTextWidth } from 'utils'

import i18n from 'i18n'

import searchSVG from 'assets/images/toolbar-search.svg'
import backSVG from 'assets/images/toolbar-back.svg'
import chevronDown24 from 'assets/images/chevron-down-gray2-24.svg'
// import checkedSVG from 'assets/images/menu-check-gray-16.svg'

import styles from './style.module.scss'

// const { Search } = Input

interface SearchPortalOwnProps extends WithTranslation {
  rootId?: string
  innerRef?: any
  presentFocus?: boolean
  defaultSearchTypeKey?: string
  onSearch?: (searchTypeKey: string, text: string | null) => void
  onSearchEnd?: () => void
  getMenu?: () => any[]
  getDefaultSearchTypeKey?: () => string
  reloadMenuWhenFocus?: boolean
  hideMenu?: boolean
  isTodo?: boolean
  searchDelay?: number
  onBlur?: () => void
  suffix?: React.ReactNode
}

// Combine with router props for internal use
interface SearchPortalProps extends SearchPortalOwnProps, RouteComponentProps<{}> {}

interface SearchPortalState {
  focused: boolean
  searchTypeKey: string
}

class SearchPortalDef extends React.Component<SearchPortalProps, SearchPortalState> {
  searchRef = React.createRef<any>()

  modalRoot: HTMLElement | null = null

  searchTypeKey: string | null = null

  textLimit = 80

  searchValue = ''

  searchMenuItems: any[] = []

  el: HTMLDivElement

  callSearchTimer: any = null

  constructor(props: SearchPortalProps) {
    super(props)
    this.el = document.createElement('div')
    const { defaultSearchTypeKey } = props

    this.searchTypeKey = defaultSearchTypeKey || null

    this.state = {
      focused: false,
      searchTypeKey: this.searchTypeKey || '',
    }
  }

  componentDidMount() {
    const { rootId, innerRef } = this.props

    const rId = rootId || 'search-container'

    this.modalRoot = document.getElementById(rId)

    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el)
    }

    // this.applyTitleTxt(title)

    if (innerRef != null) {
      if (typeof innerRef === 'function') {
        innerRef(this)
      } else {
        innerRef.current = this
      }
    }

    i18n.on('languageChanged', this.onLanguageChanged)

    if (this.props.presentFocus === true && this.searchRef.current) {
      this.searchRef.current.focus()
    }
  }

  componentDidUpdate(prevProps: SearchPortalProps) {
    const { rootId, location } = this.props

    // rootId가 바뀌면 기존 동작 유지
    if (prevProps?.rootId !== rootId) {
      if (this.modalRoot) {
        this.modalRoot.removeChild(this.el)
      }

      const rId = rootId || 'search-container'
      this.modalRoot = document.getElementById(rId)

      if (this.modalRoot) {
        this.modalRoot.appendChild(this.el)
      }
    }

    // location(라우터)가 바뀌면 강제로 리렌더링
    if (prevProps?.location?.pathname !== location?.pathname) {
      this.forceUpdate()
    }
  }

  componentWillUnmount() {
    const { innerRef } = this.props

    i18n.off('languageChanged', this.onLanguageChanged)

    if (this.modalRoot) {
      this.modalRoot.removeChild(this.el)
    }

    if (innerRef != null) {
      if (typeof innerRef !== 'function') {
        innerRef.current = null
      }
    }
  }

  onLanguageChanged = () => {
    this.reloadMenuItems(true)
  }

  getMenuItems = (reload = false) => {
    if (this.searchMenuItems.length === 0 || reload === true) {
      const { getMenu } = this.props
      if (getMenu != null) {
        this.searchMenuItems = getMenu()
      }
    }
    return this.searchMenuItems
  }

  reloadMenuItems = (update = false) => {
    this.getMenuItems(true)
    if (update === true) {
      if (this.props.getDefaultSearchTypeKey) {
        this.setSearchTypeKey(this.props.getDefaultSearchTypeKey())
      }
      this.forceUpdate()
    }
  }

  // applyTitleTxt = (title) => {
  //   let pos = Math.min(8, title.length)
  //   let w = 0
  //   let loop = true
  //   let text = ''
  //
  //   while (loop) {
  //     text = title.substring(0, pos)
  //     w = getTextWidth(text, '14px')
  //     if (w > this.textLimit) {
  //       pos -= 1
  //     } else if (w > this.textLimit - 20) {
  //       loop = false
  //     } else if (pos < title.length) {
  //       pos += 1
  //     } else {
  //       loop = false
  //     }
  //   }
  //
  //   // console.log(' ---- text width : ', w, pos, text);
  //
  //   const res = title.length === pos ? `"${text}"` : `"${text}…"`
  //
  //   this.setState({
  //     title: res,
  //   })
  // }

  // reload 시 checkParam에서 호출. preset 표시 상태 변경 필요.
  search = (text: string | null, needUpdate = false) => {
    const { onSearch } = this.props

    if (this.callSearchTimer) {
      // 이중 호출 방지.
      clearTimeout(this.callSearchTimer)
    }

    this.searchValue = text || ''

    if (needUpdate === true) {
      this.forceUpdate()
    }

    if (onSearch != null && text != null && text.trim().length > 0) {
      onSearch(this.searchTypeKey || '', text)
    } else {
      onSearch(this.searchTypeKey || '', null)
    }
  }

  setSearchTypeKey = (key: string) => {
    this.searchTypeKey = key
    this.setState({ searchTypeKey: key })

    if (this.searchValue != null && this.searchValue.length > 0) {
      this.search(this.searchValue)
    }
  }

  clearSearch = (reloadData = false) => {
    const { onSearchEnd } = this.props
    this.searchValue = ''

    if (reloadData === true) {
      this.search(null)
    }
    this.onClear()

    this.setState({ focused: false })

    if (onSearchEnd != null) {
      onSearchEnd()
    }
  }

  onKeyDown = (e: any) => {
    console.log(' ---- onKeyDown : ', e)
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.clearSearch(true)
    }
  }

  onChange = (value: string) => {
    const { searchDelay } = this.props
    this.searchValue = value
    this.forceUpdate()

    if (searchDelay != null && searchDelay > 0) {
      if (this.callSearchTimer != null) {
        clearTimeout(this.callSearchTimer)
      }
      this.callSearchTimer = setTimeout(() => {
        this.callSearchTimer = null
        this.search(this.searchValue)
      }, searchDelay)
    }
  }

  // setMode = (mode, notify) => {
  //   const { onModeChange } = this.props
  //
  //   if (mode === 'normal') {
  //     if (this.searchRef.current != null) {
  //       this.searchRef.current.input.value = ''
  //     }
  //   }
  //
  //   this.setState({
  //     mode,
  //   })
  //
  //   if (notify !== false && onModeChange != null) {
  //     onModeChange(mode)
  //   }
  // }

  onClear = () => {
    console.log('onClear')
    if (this.searchRef.current) {
      setTimeout(() => {
        this.searchRef.current?.blur()
      }, 100)
    }
  }

  onClickBackBtn = (e: any) => {
    console.log(' ---- onClickBackBtn : ', e)
    this.clearSearch(true)
  }

  onFocus = () => {
    if (this.props.reloadMenuWhenFocus) {
      this.reloadMenuItems(true)
    }
    this.setState({ focused: true })
  }

  onBlur = () => {
    //this.setState({ focused: false })
    if (this.props.onBlur != null) {
      this.props.onBlur()
    }
  }

  onChangeSearch = (value: string) => {
    this.search(value)
  }

  getSearchTypeLabel = (key: string | null) => {
    const { reloadMenuWhenFocus } = this.props
    if (key != null) {
      const menu = this.getMenuItems(reloadMenuWhenFocus)

      if (menu != null) {
        const item = menu.find((item: any) => item.key === key)

        if (item != null) {
          return item.label
        } else if (reloadMenuWhenFocus) {
          this.setState({ searchTypeKey: menu[0].key })
          return menu[0].label
        }
      }
    }
    return ''
  }

  // onEnterSearch = () => {
  //   this.search()
  // }

  // onClickSearchBtn = () => {
  //   this.search()
  // }

  // onClickSearchModeBtn = () => {
  //   this.setMode('search')
  // }

  // onClickBackBtn = () => {
  //   this.setMode('normal')
  // }

  render() {
    const { t, hideMenu, isTodo, reloadMenuWhenFocus } = this.props
    const { focused, searchTypeKey } = this.state
    // const searchButton = (
    //   <Button
    //     className={classNames('searchBtn')}
    //     type="text"
    //     htmlType="button"
    //     onClick={() => {
    //       this.onClickSearchBtn()
    //     }}
    //     icon={<img src={searchSVG} alt="search" />}
    //   />
    // )

    const altText = t('email.placeholder.search')

    const prefix =
      focused === true ? (
        <OmButton
          variant="text"
          className={classNames('backBtn')}
          icon={<img src={backSVG} alt="back" />}
          onClick={(e) => {
            this.onClickBackBtn(e)
            e.preventDefault()
            e.stopPropagation()
          }}
        />
      ) : (
        <img src={searchSVG} alt="search" />
      )

    const searchAttrs: any = {
      className: classNames({ isTodo: isTodo }),
      ref: this.searchRef,
      placeholder: altText,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onSearch: this.onChangeSearch,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onClear: this.onClear,
      // onPressEnter: this.onEnterSearch,
      prefix,
      autoFocus: true,
      // allowClear: true,
      value: this.searchValue,
      enterButton: <img src={searchSVG} alt="search" />,
      suffix: this.props.suffix,
    }

    const menuAttrs = {
      items: this.getMenuItems(reloadMenuWhenFocus),
      onClick: ({ key, domEvent }: any) => {
        console.log(' ---- onClick : ', key, domEvent)
        this.setSearchTypeKey(key)
      },
    }

    const dropdownAttrs = {
      overlayClassName: classNames('contextMenu', 'searchTypeMenu'),
      menu: menuAttrs,
      trigger: ['click'] as any,
      // onClick: (e) => {
      //   e.preventDefault()
      //   e.stopPropagation()
      // },
    }

    const searchElem = (
      <div
        className={classNames(styles.searchPortal, 'searchContainer', 'searchMode', {
          focused,
          hideMenu,
        })}
      >
        <div className={classNames('searchWrapper')}>
          {!hideMenu ? (
            <div className={classNames('searchMenu')}>
              <OmDropdownMenu {...dropdownAttrs}>
                <OmButton
                  variant="text"
                  className={classNames('searchType')}
                  icon={<img src={chevronDown24} alt="open" />}
                  iconPosition="end"
                >
                  <span>{this.getSearchTypeLabel(searchTypeKey)}</span>
                </OmButton>
              </OmDropdownMenu>
            </div>
          ) : (
            <div className={classNames('searchMenu')}></div>
          )}
          <div className={classNames('searchBox')}>
            <OmInput {...searchAttrs} />
          </div>
        </div>
      </div>
    )

    return ReactDOM.createPortal(searchElem, this.el)
  }
}

const SearchPortal = withTranslation()(withRouter(SearchPortalDef))

export default SearchPortal as any as React.ComponentType<
  Omit<SearchPortalOwnProps, keyof WithTranslation>
>
